var pre = '/system/';
export default {
  path: '/system',
  title: '系统管理',
  header: 'home',
  icon: 'md-settings',
  auth: ['system-manage'],
  children: [{
    path: "".concat(pre, "pc-user"),
    icon: 'ios-people',
    title: '系统用户管理'
  }, {
    path: "".concat(pre, "config"),
    icon: 'ios-clipboard',
    title: '平台配置'
  }, {
    path: "".concat(pre, "notice"),
    icon: 'md-megaphone',
    title: '通知公告'
  }
  // {
  //     path: `${pre}menu`,
  //     title: '菜单权限管理'
  // },
  // {
  //     path: `${pre}role`,
  //     title: '角色权限管理'
  // }
  ]
};